import { Component, Host, h } from "@stencil/core";

/**
 * @slot headline - Slot for the headline (`<h1>`)
 * @slot text - Slot for the description text (`<p>` or `<div>`)
 * @slot image - Slot for the header image (`<picture>` with 3:2 aspect ratio for mobile and 4:1 for desktop)
 */
@Component({
    tag: "ux-iws-nb-content-header",
    styleUrl: "nb-content-header.scss",
    shadow: false,
})
export class NbContentHeader {
    private baseClass = "ux-iws-nb-content-header";

    render() {
        return (
            <Host
                class={{
                    [this.baseClass]: true,
                }}
            >
                <div class={`${this.baseClass}__image`}>
                    <slot name="image" />
                </div>
                <div class="ux-row">
                    <div class="ux-col-12 ux-col-md-10 ux-col-lg-8 ux-col-xl-7 ux-u-offset-md-1">
                        <div class={`${this.baseClass}__box`}>
                            <slot name="headline" />
                            <slot name="text" />
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
